// @flow strict

import {createContext, useContext, type Context} from 'react';


export const SmsContext: Context<boolean> = createContext(false);

export function useSmsContext(): boolean {
  return useContext(SmsContext);
}
